import React from 'react';
import FullPageMessage from '../../../common/fullPageMessage/FullPageMessage';
import { BLACK_FRIDAY, LENTE_DEAL } from '../../../../constants/Copy';
import { ROUTE_TIER_OPTIONS } from '../../../../constants/Routes';

const DealIsVoorbij = ({ history, isLenteDeal }) => (
	<FullPageMessage
		button={{
			onClick: () => history.push(ROUTE_TIER_OPTIONS),
			testValue: ROUTE_TIER_OPTIONS,
			text: isLenteDeal ? LENTE_DEAL.ERROR_BUTTON : BLACK_FRIDAY.ERROR_BUTTON,
		}}
		description={isLenteDeal ? LENTE_DEAL.ERROR_TEXT : BLACK_FRIDAY.ERROR_TEXT}
		title={isLenteDeal ? LENTE_DEAL.ERROR_TITLE : BLACK_FRIDAY.ERROR_TITLE}
	/>
);

export default DealIsVoorbij;
